import { useMemo } from 'react';
import { getFetchedCategoriesIcons } from 'utils/get-fetched-categories-icons/get-fetched-categories-icons';

export function useFetchedCategoryIcons() {
  const fetchedCategoriesIcons = useMemo(() => {
    return getFetchedCategoriesIcons();
  }, []);

  return fetchedCategoriesIcons;

}